module.exports = __webpack_public_path__ + "img/bri.bd9def5c.png";